import { render } from "./ShippingOption.vue?vue&type=template&id=f37553f4"
import script from "./ShippingOption.vue?vue&type=script&lang=js"
export * from "./ShippingOption.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__